export function preserveServiceTags(originalTags, language, selectedIds) {
  const preserved = (originalTags || []).filter(tag => typeof tag === 'string' || (tag && tag.language !== language)).map(tag => (typeof tag === 'string' ? tag : tag._id)).filter(Boolean)
  return [...new Set([...preserved, ...(selectedIds || [])])]
}

export function changedServiceMedia(form, original) {
  const fields = { serviceCoverImage: 'serviceCoverImageFileId', serviceThumbnail: 'serviceThumbnailFileId' }
  return Object.keys(fields).filter(field => {
    const current = form[field]
    const previous = original && original[fields[field]] && original[fields[field]][form.lang]
    if (!current || !previous || !current._id || current._id !== previous._id) return true
    const previousAlt = previous.alt && previous.alt[form.lang] ? previous.alt[form.lang] : ''
    const currentAlt = form[`${field}Alt`] && typeof form[`${field}Alt`] === 'object' ? form[`${field}Alt`][form.lang] : form[`${field}Alt`]
    return (currentAlt || '') !== previousAlt
  })
}
